import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Button,
} from "reactstrap";

const CERTIFICATE_TEMPLATES = [
  require("assets/img/certificates/template1.png"),
  require("assets/img/certificates/template2.jpg"),
  require("assets/img/certificates/template3.jpg"),
  require("assets/img/certificates/template4.jpg"),
  require("assets/img/certificates/template5.jpg"),
];

const CertificateTemplateModal = ({
  isOpen,
  toggle,
  selectedTemplate,
  onSelect,
}) => {
  const [showPreview, setShowPreview] = useState(false);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  const handleSelectTemplate = (img) => {
    setPreviewTemplate(img);
  };

  // When a template is clicked open preview popup
  const handleTemplateClick = (img) => {
    setPreviewTemplate(img);
    setShowPreview(true);
  };

  const handlePreviewCancel = () => {
    setShowPreview(false);
  };

  const handlePreviewApply = () => {
    if (previewTemplate) {
      onSelect(previewTemplate);
      setShowPreview(false);
    }
  };

  return (
    <>
      {/* Selection Modal */}
      <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
        <ModalHeader toggle={toggle}>Select Certificate Template</ModalHeader>

        <ModalBody>
          <Row>
            {CERTIFICATE_TEMPLATES.map((img, index) => (
              <Col md="3" sm="6" xs="12" key={index} className="mb-4">
                <div
                  className={`template-card ${
                    previewTemplate === img ? "active" : ""
                  }`}
                  onClick={() => handleSelectTemplate(img)} // open preview
                >
                  <i
                    className={`fa-xl check-icon ${
                      previewTemplate === img
                        ? "fa-solid fa-square-check"
                        : "fa-regular fa-square"
                    }`}
                  ></i>
                  <img
                    src={img}
                    alt={`Template ${index + 1}`}
                    className="img-fluid"
                    onClick={() => handleTemplateClick(img)}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="btn-deep-blue"
            disabled={!selectedTemplate}
            onClick={handlePreviewApply}
          >
            Apply Template
          </Button>
        </ModalFooter>
      </Modal>

      {/* Preview Popup Modal */}
      <Modal
        isOpen={showPreview}
        toggle={handlePreviewCancel}
        size="xl"
        centered
        className="preview-modal"
      >
        <ModalHeader toggle={handlePreviewCancel}>Template Preview</ModalHeader>

        <ModalBody className="text-center p-0 pb-2">
          <img
            src={previewTemplate}
            alt="Preview"
            className="img-fluid preview-pop-up"
          />
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handlePreviewCancel}>
            Back
          </Button>
          <Button color="default" onClick={handlePreviewApply}>
            Apply Template
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CertificateTemplateModal;
